function Loader(props) {
    return (
      <div class="d-flex justify-content-center" style={{marginTop: props.mtop}}>
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    )
}
export default Loader